import Roulette from "./_rouletteGame";

promokit.store('roulette', new Roulette() );

let layerDetail = promokit.layer({
    el: '#layer-detail',
    buttons: '.p-roulette__btn-layer'
})

$(document).on('click', '.p-case__btn-login', ()=> promokit.login() );

/*$(document).on('click', '.p-sec1__btn-link2', (e)=>{
    e.preventDefault();
    promokit.message({
        type: 'alert',
        message: '조금만 기다려 주세요! 11월 11일에 오픈 됩니다.',
    });
});*/


promokit.page({
    caution: '#section-caution',

    cnb: true, //true, false

    topButton: true, //true, false

    footer: {
        theme: 'white' //'black', 'white'
    },

    headerButton: {
        el: '.header-button',
        cookie: false,
        home: false,
        event: false,
        update: false,
        sns: true,
        theme: 'black' //'black', 'white'
    }
});








// WEBPACK FOOTER //
// ./src/js/roulette.js